import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const ActionButtons = ({ hasSelectedFields }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-4 md:p-6 mb-6">
      <h3 className="text-lg md:text-xl font-semibold text-gray-800 mb-4">Actions rapides</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        <Button
          variant="default"
          iconName="Save"
          iconPosition="left"
          disabled={!hasSelectedFields}
          className="w-full"
        >
          Enregistrer la sélection
        </Button>
        <Button
          variant="outline"
          iconName="Share2"
          iconPosition="left"
          className="w-full"
        >
          Partager les résultats
        </Button>
        <Button
          variant="secondary"
          iconName="MessageSquare"
          iconPosition="left"
          onClick={() => navigate('/ai-chat-interface')}
          className="w-full"
        >
          Discuter avec l'IA
        </Button>
        <Button
          variant="outline"
          iconName="ClipboardList"
          iconPosition="left"
          onClick={() => navigate('/interactive-quiz-system')}
          className="w-full"
        >
          Passer un quiz
        </Button>
      </div>
    </div>
  );
};

export default ActionButtons;